var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-with-timeline"},[_c('AppChart',{attrs:{"options":_vm.mergedOptions}}),_vm._v(" "),_c('TimelineDescription',{staticClass:"chart-with-timeline__descriptor",attrs:{"events":_vm.selectedEvents}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }